import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('user-profile')
  .extendHookCollectionsFactory('user-profiles')
  .factory()

export {
  Provider as UserProfileProvider,
  useStore as useUserProfileStore,
}
